import { IDashboardComponent, IDashboardMetadata, IDashboardSectionColumn } from '../dashboard-metadata.service';
import { IReportAggregates } from '@app/shared/report/report-data.service';
import { SalesKpiDashboardFiltersComponent } from '../filters/sales/sales-kpi-dashboard-filters.component';
import { SalesKpiFooterComponent } from '../footer/sales-kpi-footer.component';
import { SalesKpiInfoComponent } from '../info/sales-kpi-info.component';
import { DateType } from '@app/shared/services/date.util';

const columns:(string|IDashboardSectionColumn)[] = [
  'Lacomnm',
  'Delamnm',
  'Delamcn',
  'Desprnm',
  'Desprds',
  // remove 'Current' form column's labels
  {
    name: 'Destaco_curr',
    label: 'Status comment'
  },
  {
    name: 'Destadt_curr',
    label: 'Expected start date'
  },
  {
    name: 'Deforus_curr',
    label: 'Forecast USD'
  },
  {
    name: 'Decatav_ds_curr',
    label: 'Catalog available'
  },
  'Molname'
];

const aggregates:IReportAggregates = {
  sum: true
};

const infoComponent:IDashboardComponent = {
  name: SalesKpiInfoComponent
};

export const SALES_KPI_DASHBOARD_CONFIG:IDashboardMetadata = {
  title: 'SALES KPI',
  filterComponent: {
    name: SalesKpiDashboardFiltersComponent
  },
  footerComponent: {
    name: SalesKpiFooterComponent
  },
  mapping: {
    Desprnm: 'customer.id',
    Delamnm: 'lam.id',
    Lacomnm: 'lamCompany.id',
    Delamcn: 'lamContact.id',
    Molname: 'gbdm.id',
    Demoddt_FROM: 'date_FROM',
    Demoddt_TO: 'date_TO'
  },
  fixedFilters: {
    date_FROM: DateType.THIRTY_DAYS_AGO,
    date_TO: DateType.TODAY
  },
  reports: [
    {
      id: 247,
      key: 'NEW_LEADS',
      code: 'LEADS',
      comments: '',
      fixedFilters: {
        Deexcld: '1',
        Desprst_ds: '@PRESALES@',
        Desprst_ds_prev: '@EMPTY@@TOAPPROVE@'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      id: 247,
      key: 'NEW_LIVE',
      code: 'NEW_LIVE',
      comments: '',
      fixedFilters: {
        Deexcld: '1',
        Desprst_ds: '@STEADY@',
        Desprst_ds_prev: '@PRESALES@'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      id: 247,
      key: 'NEW_SETUP',
      code: 'NEW_SETUP',
      comments: '',
      fixedFilters: {
        Deexcld: '1',
        Desprst_ds: '@ACT@',
        Desprst_ds_prev: '@PRESALES@'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      id: 247,
      key: 'NEW_SLEEP',
      code: 'NEW_SLEEP',
      comments: '',
      fixedFilters: {
        Deexcld: '1',
        Desprst_ds: '@SLEEP@',
        Desprst_ds_prev: '@PRESALES@'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      id: 247,
      key: 'NEW_CLOSE',
      code: 'NEW_CLOSE',
      comments: '',
      fixedFilters: {
        Deexcld: '1',
        Desprst_ds: '@CLOSED@',
        Desprst_ds_prev: '@PRESALES@'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      id: 247,
      key: 'CATALOG_NO_YES',
      code: 'CATALOG_NO_YES',
      comments: '',
      fixedFilters: {
        Deexcld: '1',
        Decatav_ds: '1',
        Decatav_ds_prev: '0'
      },
      columns,
      aggregates,
      infoComponent
    },

    {
      id: 247,
      key: 'NEW_WINS',
      comments: '',
      fixedFilters: {
        Dewinch_ds: 'WON',
        Deequals: 'pck_tools.equals_V(Dewinch_ds, Dewinch_ds_prev)',
        Demoddt_FROM: 'sysdate-30',
        Demoddt_TO: null
      },
      columns,
      aggregates,
      infoComponent
    }

  ]
};